export default "__VITE_ASSET__qUWjDiJ2__"